const getSmartCaptchaSiteKey = () => {
    const meta = document.querySelector('meta[name="yandex-smartcaptcha-key"]');
    return meta ? meta.getAttribute('content') : null;
}

const smartCaptchaByForm = new WeakMap();
const smartCaptchaInflightByForm = new WeakMap();

const getCaptcha = (formEl) => {
    const sc = window.smartCaptcha;
    const sitekey = getSmartCaptchaSiteKey();

    if (!sc || !sitekey) {
        return Promise.reject(new Error('SmartCaptcha not initialized or sitekey missing'));
    }

    if (!(formEl instanceof HTMLFormElement)) {
        return Promise.reject(new Error('Pass form element into getCaptcha(form)'));
    }

    const inflight = smartCaptchaInflightByForm.get(formEl);
    if (inflight) return inflight;

    let entry = smartCaptchaByForm.get(formEl);

    if (!entry) {
        let holder = formEl.querySelector('.smartcaptcha-container,.smartcaptcha-holder');

        if (!holder) {
            holder = document.createElement('div');
            holder.className = 'smartcaptcha-holder';
            holder.style.position = 'absolute';
            holder.style.left = '-9999px';
            holder.style.bottom = '0';
            formEl.appendChild(holder);
        }

        const widgetId = sc.render(holder, {
            sitekey,
            invisible: true,
            callback: () => {},
        });

        entry = { widgetId };
        smartCaptchaByForm.set(formEl, entry);

        sc.subscribe(widgetId, 'success', (token) => {
            const p = smartCaptchaInflightByForm.get(formEl);
            p?.__resolve?.(token);
        });

        sc.subscribe(widgetId, 'token-expired', () => {
            const p = smartCaptchaInflightByForm.get(formEl);
            p?.__reject?.(new Error('Token expired'));
        });

        sc.subscribe(widgetId, 'network-error', () => {
            const p = smartCaptchaInflightByForm.get(formEl);
            p?.__reject?.(new Error('Network error'));
        });

        sc.subscribe(widgetId, 'javascript-error', () => {
            const p = smartCaptchaInflightByForm.get(formEl);
            p?.__reject?.(new Error('JS error'));
        });
    }

    const { widgetId } = entry;

    let resolveCaptcha;
    let rejectCaptcha;
    const promise = new Promise((resolve, reject) => {
        resolveCaptcha = resolve;
        rejectCaptcha = reject;
    });

    promise.__resolve = (token) => {
        smartCaptchaInflightByForm.delete(formEl);
        resolveCaptcha(typeof token === 'string' && token.length ? token : '');
    };

    promise.__reject = (error) => {
        smartCaptchaInflightByForm.delete(formEl);
        rejectCaptcha(error);
    };

    smartCaptchaInflightByForm.set(formEl, promise);

    try {
        sc.reset?.(widgetId);
        sc.execute(widgetId);
    } catch (e) {
        smartCaptchaInflightByForm.delete(formEl);
        rejectCaptcha(e);
    }

    return promise;
}

window.getCaptcha = getCaptcha;
